import { BACKEND_PRIVATE } from '@/api/base'
import { WalletGroup } from '@/constants/blockchain'

interface SendOfferPayload {
  budget: string
  deadline: string
  freelancer_wallet: string
  group: WalletGroup
  application_id: number
}

export async function sendOffer(payload: SendOfferPayload) {
  return BACKEND_PRIVATE.post('/me/jobs/simple/offers/send', { payload })
}

export async function declineOffer({ id, comment }: { id: number; comment: string }) {
  return BACKEND_PRIVATE.post(`/me/jobs/simple/offers/decline?id=${id}`, { comment })
}

export async function applyOffer(id: number) {
  return BACKEND_PRIVATE.post(`/me/jobs/simple/offers/apply?id=${id}`)
}
